module.exports = __webpack_public_path__ + "img/notStonks.620752e7.svg";